const makeFileUrl = (media) => {
  const endpoint = "https://hola-filestore.nyc3.digitaloceanspaces.com/public/";

  return endpoint + media.filename;
};

export default makeFileUrl;
